import React from 'react'
import useMobile from '../../hooks/useMobile'
import usePermission from '../../hooks/usePermission'
import { usePlantTechnicalView } from './hooks/usePlantTechnicalView'
import PlantTechnicalViewDesktop from './components/PlantTechnicalViewDesktop'
import PlantTechnicalViewMobileView from './components/PlantTechnicalViewMobileView'

const PlantTechnicalView = () => {
  const isMobile = useMobile()
  const logic = usePlantTechnicalView()
  const permissions = usePermission()

  if (isMobile) {
    return <PlantTechnicalViewMobileView logic={logic} permissions={permissions} />
  }

  return <PlantTechnicalViewDesktop logic={logic} permissions={permissions} />
}

export default PlantTechnicalView
